module.exports = __webpack_public_path__ + "static/media/Reflection.2b0d84c4.png";